/*
  GW mobile card gallery (collection pages only, screens up to 749px).
  Shoppers swipe a card's picture left/right to see up to 4 photos; a tap still opens the product.
  Dots at the bottom of the picture show how many photos there are. Photos 2-4 load only when the shopper
  starts swiping that card. Desktop is unchanged (hover shows the second photo).

  How it works: a self-contained swipe strip (white background, all photos inside it) is laid over the theme's
  picture, so theme image effects cannot hide it. Photo 1 reuses the image the theme already loaded when
  available (no second download). Photo list comes from snippets/gw-card-condition.liquid (hidden .gw-gallery).
  Only cards inside #product-grid: swipe rows (hub "Just in", Recently viewed) keep one photo.
  Watches only the product grid area for new cards (Load more, filters, sorting), not the whole page, and does
  nothing at all on desktop.
  Loaded from sections/main-collection-product-grid.liquid. Styles are injected below (one place).
  The theme stretches every direct child of .media to full height from the top, so the dots override top/height.
*/
(function () {
  if (window.__gwCardGallery) return;
  window.__gwCardGallery = true;

  var mq = window.matchMedia('(max-width: 749px)');

  var css =
    '.media.gw-gal > .gw-gal__track{position:absolute !important;top:0 !important;left:0 !important;width:100% !important;height:100% !important;display:flex !important;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;z-index:1;background:#FFFFFF;opacity:1 !important;visibility:visible !important;}' +
    '.gw-gal .gw-gal__track::-webkit-scrollbar{display:none;}' +
    '.gw-gal .gw-gal__slide{position:relative;display:block;flex:0 0 100%;width:100%;height:100%;overflow:hidden;background:#FFFFFF;scroll-snap-align:start;scroll-snap-stop:always;}' +
    '.gw-gal .gw-gal__slide img{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:contain;opacity:1;visibility:visible;}' +
    '.gw-gal .gw-gal__slide img[data-gw-src]{visibility:hidden;}' +
    '.media.gw-gal > .gw-gal__dots{position:absolute !important;top:auto !important;bottom:0.6rem !important;left:0 !important;right:0 !important;width:100% !important;height:auto !important;display:flex !important;justify-content:center;align-items:center;gap:0.5rem;pointer-events:none;z-index:2;opacity:1 !important;}' +
    '.gw-gal .gw-gal__dots span{flex:0 0 0.5rem;width:0.5rem;height:0.5rem;border-radius:50%;background:rgba(26,27,24,0.22);transition:background-color 0.2s ease;}' +
    '.gw-gal .gw-gal__dots span.is-active{background:rgba(26,27,24,0.7);}';

  function addStyle() {
    if (document.getElementById('gw-gal-style')) return;
    var s = document.createElement('style');
    s.id = 'gw-gal-style';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function loadImages(track) {
    if (track.__gwLoaded) return;
    track.__gwLoaded = true;
    track.querySelectorAll('img[data-gw-src]').forEach(function (img) {
      img.addEventListener('load', function () { img.removeAttribute('data-gw-src'); }, { once: true });
      img.src = img.getAttribute('data-gw-src');
    });
  }

  function build(wrapper) {
    if (wrapper.getAttribute('data-gw-gal')) return;
    wrapper.setAttribute('data-gw-gal', '1');

    var data = wrapper.querySelector('.gw-gallery');
    if (!data) return;
    var urls = (data.getAttribute('data-images') || '').split('|').map(function (u) { return u.trim(); }).filter(Boolean);
    if (urls.length < 2) return;

    var media = wrapper.querySelector('.card__media .media');
    if (!media) return;

    // Photo 1: reuse what the theme already loaded, if it has finished loading.
    var themeImg = media.querySelector('picture img');
    var firstSrc = (themeImg && themeImg.complete && themeImg.currentSrc) ? themeImg.currentSrc : urls[0];

    var alt = data.getAttribute('data-alt') || '';
    var track = document.createElement('div');
    track.className = 'gw-gal__track';

    urls.forEach(function (u, i) {
      var slide = document.createElement('div');
      slide.className = 'gw-gal__slide';
      var img = document.createElement('img');
      img.alt = alt;
      img.decoding = 'async';
      if (i === 0) {
        img.src = firstSrc;
      } else {
        img.setAttribute('data-gw-src', u);
      }
      slide.appendChild(img);
      track.appendChild(slide);
    });

    var dots = document.createElement('div');
    dots.className = 'gw-gal__dots';
    dots.setAttribute('aria-hidden', 'true');
    for (var j = 0; j < urls.length; j++) {
      var d = document.createElement('span');
      if (j === 0) d.className = 'is-active';
      dots.appendChild(d);
    }

    media.classList.add('gw-gal');
    media.appendChild(track);
    media.appendChild(dots);

    track.addEventListener('touchstart', function () { loadImages(track); }, { passive: true });
    var timer;
    track.addEventListener('scroll', function () {
      loadImages(track);
      clearTimeout(timer);
      timer = setTimeout(function () {
        var idx = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        Array.prototype.forEach.call(dots.children, function (dot, k) {
          dot.classList.toggle('is-active', k === idx);
        });
      }, 60);
    }, { passive: true });
  }

  function run() {
    if (!mq.matches) return;
    addStyle();
    document.querySelectorAll('#product-grid .card-wrapper').forEach(build);
  }

  var pending;
  function schedule() {
    clearTimeout(pending);
    pending = setTimeout(run, 100);
  }

  var observer = null;
  function watch() {
    if (observer || !mq.matches) return;
    // Cards added by "Load more", filters or sorting all land inside the product grid area.
    var area = document.querySelector('.product-grid-container') || document.getElementById('ProductGridContainer');
    if (!area) return;
    observer = new MutationObserver(schedule);
    observer.observe(area, { childList: true, subtree: true });
  }

  function init() {
    run();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  if (mq.addEventListener) mq.addEventListener('change', init);
})();
